import { useConfirmStore } from "@/stores/confirm.store";
import { AlertTriangle } from "lucide-react";
import { useEffect } from "react";

export function ConfirmDialog() {
  const { open, options, resolveWith } = useConfirmStore();

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") resolveWith(false);
      if (e.key === "Enter") resolveWith(true);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, resolveWith]);

  if (!open || !options) return null;

  const danger = options.danger ?? false;

  return (
    <div
      className="fixed inset-0 z-[110] flex items-center justify-center bg-black/40 p-4"
      onClick={() => resolveWith(false)}
      role="presentation"
    >
      <div
        role="alertdialog"
        aria-modal="true"
        aria-label={options.title ?? "Confirm"}
        className="w-full max-w-md rounded-xl bg-white p-6 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start gap-3">
          {danger && <AlertTriangle className="mt-0.5 h-6 w-6 flex-shrink-0 text-red-500" />}
          <div className="flex-1">
            {options.title && (
              <h2 className="text-lg font-semibold text-zinc-900">{options.title}</h2>
            )}
            <p className="mt-1 text-sm text-zinc-600">{options.message}</p>
          </div>
        </div>

        <div className="mt-6 flex justify-end gap-3">
          <button
            type="button"
            onClick={() => resolveWith(false)}
            className="rounded-lg px-4 py-2 text-sm font-medium text-zinc-700 hover:bg-zinc-100"
          >
            {options.cancelLabel ?? "Cancelar"}
          </button>
          <button
            type="button"
            onClick={() => resolveWith(true)}
            className={`rounded-lg px-4 py-2 text-sm font-medium text-white ${
              danger ? "bg-red-600 hover:bg-red-700" : "bg-zinc-900 hover:bg-zinc-800"
            }`}
          >
            {options.confirmLabel ?? "Confirmar"}
          </button>
        </div>
      </div>
    </div>
  );
}
